var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16,
    width: 15,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M7.5 15.2A7.2 7.2 0 1 0 7.5.8a7.2 7.2 0 0 0 0 14.4zM4.8 7.1a.9.9 0 1 0 0-1.8.9.9 0 0 0 0 1.8zm6.3-.9a.9.9 0 1 1-1.8 0 .9.9 0 0 1 1.8 0zm-.418 4.982a.9.9 0 1 0-1.273-1.273 2.7 2.7 0 0 1-3.818 0 .9.9 0 0 0-1.273 1.273 4.5 4.5 0 0 0 6.364 0z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile);
export default __webpack_public_path__ + "static/media/smile.e218613ef07648b3f9075b41edbe723a.svg";
export { ForwardRef as ReactComponent };